import { render, staticRenderFns } from "./modalAceptarResidente.vue?vue&type=template&id=3f86a1fe&scoped=true"
import script from "./modalAceptarResidente.vue?vue&type=script&lang=js"
export * from "./modalAceptarResidente.vue?vue&type=script&lang=js"
import style0 from "./modalAceptarResidente.vue?vue&type=style&index=0&id=3f86a1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f86a1fe",
  null
  
)

export default component.exports